import React from 'react';
import BaseNode from './BaseBlockNode';
import { makeParams } from '../../helpers/node';
import { PowerSoftConstraintNodeConfig } from '../../../constants';
import { renderPhasesParams } from '../../../constants/phases';

function PowerSoftConstraintNode(props) {
  const {
    presentLoadPhA, presentLoadPhB, presentLoadPhC,
    presentPowerPhA, presentPowerPhB, presentPowerPhC,
  } = props;

  return (
    <BaseNode
      {...props}
      staticParams={makeParams(PowerSoftConstraintNodeConfig().staticParams)(props)}
      dynamicParams={[
        ...renderPhasesParams({
          presentLoadPhA,
          presentLoadPhB,
          presentLoadPhC,
          presentPowerPhA,
          presentPowerPhB,
          presentPowerPhC,
        }),
      ]}
      hidePhases
    />
  );
}

export default PowerSoftConstraintNode;
